import { Component } from '@angular/core';

@Component({
  selector: 'fastr-ui-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {}
